import { getMetadata, ref } from "firebase/storage"
import { filter, flatMap, get, groupBy, map, sumBy, uniqBy } from "lodash-es"

import { firebaseStorage } from "@firebaseConfig/clientApp"
import { getRemoteConfigValue } from "@firebaseConfig/remoteConfigUtil"

export const getServiceFeesConfig = () => {
  try {
    const serviceFees = getRemoteConfigValue("serviceFees")
    return JSON.parse(serviceFees)
  } catch (error) {
    console.log("Error parsing serviceFees")
  }
}

export const getTicketWithServiceFees = (price: string | number) => {
  const serviceConfigValue = getServiceFeesConfig()
  const stripeConfigFees = get(serviceConfigValue, "stripe", {})
  const service = get(serviceConfigValue, "service", {})

  const parsePrice = parseFloat(price as string)
  const serviceFees =
    parsePrice * (service?.percentage / 100) + service?.constant
  const stripeFees =
    parsePrice * (stripeConfigFees?.percentage / 100) +
    stripeConfigFees?.constant
  const finalTotal = parsePrice + serviceFees + stripeFees

  return {
    payingPrice: finalTotal,
    service,
    stripeConfigFees,
    serviceFees,
    stripeFees,
  }
}

const calculateFees = (groupedTickets) => {
  return groupedTickets.map((ticket) => {
    const serviceFee =
      (ticket.totalTicketPrice + ticket.totalAddOnsPrice) * 0.025 // 2.5% Service Fee
    const stripeFee =
      (ticket.totalTicketPrice + ticket.totalAddOnsPrice) * 0.029 + 0.3 // 2.9% + $0.30 Stripe Fee

    const finalPayingPrice =
      ticket.totalTicketPrice + ticket.totalAddOnsPrice + serviceFee + stripeFee

    return {
      ...ticket,
      serviceFee: parseFloat(serviceFee.toFixed(2)),
      stripeFee: parseFloat(stripeFee.toFixed(2)),
      finalPayingPrice: parseFloat(finalPayingPrice.toFixed(2)),
    }
  })
}

export function groupTicketsWithPrice(groupedTickets) {
  const result = flatMap(groupedTickets, (ticketGroup) => {
    const addOnGrouped = groupBy(ticketGroup, (ticket) => {
      const selectedAddOns = ticket.ticketAddOns
        ?.filter((addOn) => addOn.isSelected)
        .map((addOn) => addOn.ticketName)
        .sort()
        // .join(", ")
        .join(" + ")
      return selectedAddOns || "No Add-Ons"
    })

    return map(addOnGrouped, (group, addOnKey) => {
      const count = group.length
      const ticket = group[0] // Use first ticket as reference
      const ticketName = ticket.ticketName
      const ticketPrice = ticket.ticketPrice
      const totalTicketPrice = count * ticketPrice

      const selectedAddOns = uniqBy(
        filter(flatMap(group, "ticketAddOns"), { isSelected: true }),
        "ticketId",
      )

      const addOnPrice = sumBy(selectedAddOns, "ticketPrice")
      const totalAddOnsPrice = count * addOnPrice
      const finalPrice = totalTicketPrice + totalAddOnsPrice

      // const addOnText = addOnKey !== "No Add-Ons" ? `+ ADD-ON ${addOnKey}` : ""
      const addOnText = addOnKey !== "No Add-Ons" ? `+ ${addOnKey}` : ""

      const parsePrice = parseFloat(`${finalPrice}`)

      // const finalTotal = parsePrice + serviceFees + stripeFees
      const finalTotal = parsePrice

      return {
        ...ticket,
        ticketQuantity: count,
        totalTicketPrice,
        ticketAddOns: selectedAddOns,
        addOnsPrice: addOnPrice,
        totalAddOnsPrice,
        finalPrice,
        finalTotal,
        label: `x${count} ${ticketName} ${addOnText}`,
        attendeeIds: group.map((t) => t.attendeeId),
      }
    })
  })

  return result
}

export const getCustomMetadata = async (eventId) => {
  const fileRef = ref(firebaseStorage, `pixelated_event_images/${eventId}.png`)

  try {
    const metadata = await getMetadata(fileRef)
    return metadata.customMetadata
  } catch (error) {
    console.log("Error fetching metadata:", error)
    return null
  }
}
